import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

import { LoginForm, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const LoginView = (props) => {
  const [logo, setLogo] = useState(null);
  const [loginImage, setLoginImage] = useState(null);
  const [appleStore, setApple] = useState(null);
  const [googlePlay, setGoogle] = useState(null);

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo);
      setLoginImage(appInfo.loginImage);
      setApple(appInfo.appleStore);
      setGoogle(appInfo.googlePlay);
    }
  };

  useEffect(() => {
    getAppInfo();
  });

  return (
    <div className="loginView">
      <div
        className="loginView__bg"
        style={{
          backgroundImage: `linear-gradient(transparent,rgba(0,0,0,.7)), url(${loginImage})`,
        }}
      >
        <div className="loginView__bg--content">
          <h3>{i18n.translate('loginScreen.title')}</h3>
          <div className="buttonWrapper">
            <div className="button__container">
              {'Easily download this program at your app store:'}
              <div className="buttons small">
                {appleStore && (
                  <a href={appleStore} target="_blank" rel="noopener noreferrer">
                    <img src={apple} alt="App store" />
                  </a>
                )}
                {googlePlay && (
                  <a href={googlePlay} rel="noopener noreferrer">
                    <img src={google} alt="Google Play" />
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="poweredBy">{'POWERED BY'}</div>
          <img
            src="https://front.travpromobile.com/logos/logo_white.png"
            alt="Company Logo"
            className="loginView__content--logo-trav"
          />
        </div>
      </div>
      <div className="loginView__content">
        <img src={logo} className="loginView__content--logo" alt="Logo" />
        <LoginForm path={props.match.path} />
      </div>
      <style>
        {
          '\
        #openWidget { display: block; bottom: 4rem; } '
        }
      </style>
    </div>
  );
};

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
};
